import React from "react";
import {ReactComponent as ServiceKo} from '../../resources/images/result_ko.svg';
import './ServiceUnavailablePage.css';

export class ServiceUnavailablePage extends React.Component<any, any> {
    render() {
        return <div id={"main-container-service-unavailable"}>
            <div className={"service-unavailable-logo-container"}>
                <ServiceKo className={"service-unavailable-logo"}/>
            </div>
            <p className={"service-unavailable-title"}>In questo momento il sito non è disponibile.</p>
            <p className={"service-unavailable-paragraph"}>Attendi qualche istante e prova a ricaricare la pagina. <br></br> Grazie per la pazienza.</p>
        </div>
    }
}